<template>
  <form class="form-horizontal" @submit.prevent="updateEmail">
    <div class="row">
      <label class="col-sm-2 col-form-label">Email ID
        <strong class="text-danger">*</strong>
      </label>
      <div class="col-sm-6">
        <div class="form-group">
          <input type="email" :disabled="!adminRoles.includes(user.userType) " class="form-control" required v-model.trim="customer.email">
          <span class="form-text">Enter and update the customer's email id which will be used both for sending emails and login into the portal.</span>
        </div>
      </div>
      <div class="col-sm-4">
        <button class="btn btn-danger mt-0 text-white" :disabled="!customer.email || !adminRoles.includes(user.userType) ">Update Email</button>
      </div>
    </div>
  </form>
</template>

<script>
import { db,functions } from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "EmailUpdate",
  computed: {
    custID() {
      return this.$store.getters["customer/id"];
    },
    docID() {
      return this.$store.getters["customer/docID"];
    },
    user() {
      return this.$store.getters.user;
    }
  },
  data() {
    return {
      adminRoles: ['admin', 'super-admin'],
      customer: {
        email: this.$store.getters["customer/email"]
      }
    };
  },
  methods: {
    async getCollaborators(){
      let objRef=await db.collection("users")
          .doc(this.docID)
          .get();
      let userObj=objRef.data();
      if (userObj.collaborators) {
        let isEmailExistsInCollaborators=userObj.collaborators.some(el =>  el.email===this.customer.email)
        console.log(isEmailExistsInCollaborators)
        return isEmailExistsInCollaborators
      } else {
        return false
      }
    },
    async updateEmail() {
      // Check the email id field is not blank
      if (this.customer.email) {
        this.customer.email = this.customer.email.toLowerCase()
        // Check if the provided email id is actually an email or not
        const emailCheckRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailCheckRegex.test(this.customer.email)) {
          // Now we know that the entered email is a completely valid email
          // Set the asyncDone to false
          this.$store.dispatch("async/stateUpdate", { state: false });
          let response= await this.getCollaborators();
          console.log(response)
          if(response){
            this.$store.dispatch("async/stateUpdate", { state: true });
            this.addLog({
              message: `This email already exists in collaborators of this user`,
              level: "danger"
            })
            swal({
              title: "Invalid Email!",
              text: "This email already exists in collaborators of this user",
              type: "error"
            })
            // Show the alert to the admin for 5 seconds
            return false;
          }
          // Call firebase cloud function updateUserEmail to update the email id in the firebase auth as well as firestore users collection by passing the fireabse auth UID and the new updated email id
          // const updateUserEmail = functions.httpsCallable("updateUserEmail");
          // updateUserEmail({
          //   uid: this.docID,
          //   newEmail: this.customer.email
          // })
          this.$http.post("/auth/update-user-email", {
            uid: this.docID,
            newEmail: this.customer.email,
            grant_type: 'token',
          })
            .then(async result => {
              if (result.data.success) {
                await this.$http.post('/algolia/reinitialize-user-all-record', {
                  grant_type: 'token',
                  uid : this.docID,
                })
                // Update the email to teh Vuex state
                this.$store.dispatch("customer/emailUpdate", {
                  email: this.customer.email
                });
                await this.updateEmailInSupervisors()

                // set asyncDone to true
                this.$store.dispatch("async/stateUpdate", { state: true });

                // Show the alert to the admin for 8 seconds
                this.$store.dispatch("alert/update", {
                  type: "success",
                  message: `The email id of the Customer (Cust ID#: ${
                    this.custID
                  }) has seccessfully been updated. Please provide this updated email to the user for login.`,
                  show: true
                });
                this.addLog({
                  message:`The email id of the Customer (Cust ID#: ${
                      this.custID
                  }) has seccessfully been updated. Please provide this updated email to the user for login.
                  `,
                  level: "info"
                })
                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", {
                    show: false
                  });
                }, 8000);
              }
            })
            .catch(err => {
              // set asyncDone to true
              this.$store.dispatch("async/stateUpdate", { state: true });

              // Show the alert to the admin for 5 seconds
              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err,
                show: true
              });
              this.addLog({
                message:err,
                level: "danger"
              })
              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", {
                  show: false
                });
              }, 5000);
            });
        } else {
          // Show the alert to the admin for 5 seconds
          this.$store.dispatch("alert/update", {
            type: "danger",
            message: "Please enter a valid Email ID",
            show: true
          });

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", {
              show: false
            });
          }, 5000);
        }
      } else {
        // Show the alert to the admin for 5 seconds
        this.$store.dispatch("alert/update", {
          type: "danger",
          message: "Please enter a valid Email ID",
          show: true
        });
        this.addLog({
          message:"Please enter a valid Email ID",
          level: "danger"
        })
        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", {
            show: false
          });
        }, 5000);
      }
    },
    async updateEmailInSupervisors () {
      // console.log(this.docID);
      const userRef = await db.collection('users').doc(this.docID).get();
      // console.log(userRef.data())
      const user = userRef.data()
      if (user.supervisors && user.supervisors.length > 0) {
        // update all supervisors
        for (const supervisor of user.supervisors) {
          const supervisorRef = await db.collection('users').doc(supervisor.supervisorId).get();
          const supervisorObj = supervisorRef.data();
          const collaborators = supervisorObj.collaborators
          for (const collaborator of collaborators) {
            if (collaborator.uid === this.docID) {
              collaborator.email = this.customer.email
            }
          }
          await db.collection('users').doc(supervisor.supervisorId).update({
            collaborators
          });
        }
      }
      if (user.collaborators && user.collaborators.length > 0) {
        for (const collaborator of user.collaborators) {
          if (collaborator.uid) {
            const collaboratorRef = await db.collection('users').doc(collaborator.uid).get();
            const collaboratorObj = collaboratorRef.data();
            const supervisors = collaboratorObj.supervisors
            for (const supervisor of supervisors) {
              if (supervisor.supervisorId === this.docID) {
                supervisor.supervisorEmail = this.customer.email
              }
            }
            await db.collection('users').doc(collaborator.uid).update({
              supervisors
            });
          }
        }
      }
      // update indices in algolia
      await this.$http.post('/algolia/reinitialize-user-all-record', {
        grant_type: 'token',
        uid : this.docID,
      });
    }
  }
};
</script>
